import { waitForFrame } from '../utility-functions/utility-functions';
import '../../../css/bem/_scroll-to-top.scss';

let lastScrollTop = 0,
    delta = 5,
    st = 0,
    scrollToTopElement:HTMLElement,
    scrollTopLimit = 100;

const hasScrolled = () => {
    st = document.body.scrollTop || document.documentElement.scrollTop;

    if (Math.abs(lastScrollTop - st) <= delta)
        return;

    if (st > scrollTopLimit) {
        if (!scrollToTopElement.classList.contains('active')) {
            scrollToTopElement.classList.add('active');
        }
    } else {
        if (scrollToTopElement.classList.contains('active')) {
            scrollToTopElement.classList.remove('active');
        }
    }
    lastScrollTop = st;
};

export const scrollPageToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

const createElements = () => {
    scrollToTopElement = document.createElement('div');
    scrollToTopElement.innerHTML = '<span class="scroll-to-top__icon"></span>';
    scrollToTopElement.classList.add('scroll-to-top', 'js-scroll-to-top');
    document.querySelector('body').appendChild(scrollToTopElement);
};

const createEvents = () => {
    window.onscroll = () => waitForFrame().then(hasScrolled);
    scrollToTopElement.addEventListener('click', scrollPageToTop);
};

export const scrollToTop = () => {
    createElements();  
    createEvents();
};
